import { type Theme } from '@mui/material';
import { covElevatedSurfaceBase } from '~/modules/covenants/CovenantsDataForm/commonStyles.ts';

export const styles = {
  selectorWrap: (theme: Theme) => ({
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '100%',
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    paddingInline: theme.spacing(2),
    background: theme.palette.background.default,
  }),
  selectorCard: (theme: Theme) => ({
    ...covElevatedSurfaceBase(theme),
    width: '100%',
    maxWidth: theme.spacing(80),
    p: theme.spacing(4),
  }),
  selectorTitle: {
    textAlign: 'center',
  },
  selectorForm: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  selectorSubmit: (theme: Theme) => ({
    textTransform: 'none',
    borderRadius: theme.spacing(1),
    fontWeight: 700,
    alignSelf: 'center',
    minWidth: theme.spacing(30),
  }),
  selectorDialog: (theme: Theme) => ({
    '& .MuiDialog-paper': {
      width: '100%',
      maxWidth: `${theme.breakpoints.values.sm}px`,
    },
  }),
} as const;
